import type { QueryClient } from '@tanstack/react-query';
import { isRedirect, redirect } from '@tanstack/react-router';
import { getSandboxQueryOptions } from '@/lib/queries/loop-planner/useGetSandbox';
import { isHttpError } from '@/lib/utils/common/isHttpError';

export const ensureSandboxOrRedirect = async ({
  loopId,
  org,
  queryClient,
}: {
  loopId: number;
  org: string;
  queryClient: QueryClient;
}) => {
  try {
    await queryClient.ensureQueryData(getSandboxQueryOptions({ loopId }));
  } catch (error) {
    if (isRedirect(error)) {
      throw error;
    }
    if (isHttpError(error, 404)) {
      throw redirect({
        to: '/org/$org/loop/$loopId/planner',
        params: { org, loopId },
      });
    }
    throw error;
  }
};
